<template>
  <div id="res-topology-wrapper" class="res-topology-wrapper" :style="`height:${height}px`">
    <loading-block v-if="loading" />
    <div v-else id="topology" class="topology" :style="topologyStyle">
      <account-topology :dataSource="data" />
    </div>
    <toolbar @click="menuClick" />
  </div>
</template>

<script>
import * as R from 'ramda'
import AccountTopology from './Account'
import Toolbar from './Toolbar'

export default {
  name: 'ResTopology',
  components: {
    AccountTopology,
    Toolbar,
  },
  props: {
    loading: Boolean,
    dataSource: Object,
  },
  data () {
    return {
      height: 800,
      scale: 1,
      translateX: 0,
      translateY: 0,
      isDraging: false,
      startX: 0,
      startY: 0,
      initialX: 0,
      initialY: 0,
      initExpand: 0,
      data: {},
    }
  },
  computed: {
    topologyStyle () {
      return `transform:translate(${this.translateX}px, ${this.translateY}px) scale(${this.scale});`
    },
  },
  watch: {
    dataSource: {
      handler: function () {
        this.data = this.addId(this.dataSource, false)
      },
      deep: true,
      immediate: true,
    },
  },
  mounted () {
    const that = this
    window.addEventListener('resize', function (event) {
      that.getHeight()
    })
    const container = document.getElementById('res-topology-wrapper')
    container.addEventListener('mousewheel', function (e) {
      e.preventDefault()
      const maxScale = 4
      const minScale = 0.3
      const element = document.getElementById('topology')
      const rect = element.getBoundingClientRect()
      const offsetX = e.clientX - rect.left
      const offsetY = e.clientY - rect.top
      const prevScale = that.scale
      const delta = e.deltaY || e.detail || e.wheelDelta
      that.scale += delta * -0.001
      that.scale = Math.min(Math.max(minScale, that.scale), maxScale)
      const newX = offsetX * (that.scale / prevScale - 1)
      const newY = offsetY * (that.scale / prevScale - 1)
      that.translateX -= newX
      that.translateY -= newY
    })
    container.addEventListener('mousedown', (e) => {
      that.isDraging = true
      that.startX = e.clientX
      that.startY = e.clientY
      that.initialX = that.translateX
      that.initialY = that.translateY
    })
    document.addEventListener('mousemove', (e) => {
      if (that.isDraging) {
        const dx = e.clientX - that.startX
        const dy = e.clientY - that.startY
        that.translateX = that.initialX + dx
        that.translateY = that.initialY + dy
      }
    })
    document.addEventListener('mouseup', () => {
      that.isDraging = false
    })
    this.getHeight()
  },
  beforeDestroy () {
    if (window?.removeEventListener) {
      window.removeEventListener('resize')
    }
  },
  methods: {
    getHeight () {
      const wrapper = document.getElementById('res-topology-wrapper')
      this.height = window.innerHeight - wrapper.getBoundingClientRect().top - 30
    },
    menuClick (type) {
      if (type === 'expand') {
        this.data = this.addId(this.dataSource, true)
      } else if (type === 'fold') {
        this.data = this.addId(this.dataSource, false)
      } else if (type === 'zoomIn') {
        this.scale += 0.1
      } else if (type === 'zoomOut') {
        this.scale -= 0.1
      }
    },
    addId (data, expand = false) {
      const d = R.clone(data || {})
      d.isChildrenShow = true
      d.showField = 'isChildrenShow'
      const { accounts = [] } = d
      accounts.forEach((account, accountIdx) => {
        account.isChildrenShow = expand
        account.showField = `accounts[${accountIdx}].isChildrenShow`
        account.showId = `${accountIdx}`
        const { hosts = [] } = account
        hosts.forEach((host, hostIdx) => {
          host.isChildrenShow = expand
          host.showField = `accounts[${accountIdx}].hosts[${hostIdx}].isChildrenShow`
          host.showId = `${accountIdx}-${hostIdx}`
        })
      })
      return d
    },
  },
}
</script>

<style lang="scss">
@import "@Network/sections/Topology/index.scss";
.res-topology-wrapper {
  width: 100%;
  // padding-top: 50px;
  overflow: hidden;
  position: relative;
  cursor: grab;
}
.topology {
  margin-top: 50px;
  transform-origin: 0 0;
  cursor: grab;
  user-select: none;
}
</style>
